import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import {
  DateRange,
  DefaultMatCalendarRangeStrategy,
  MatRangeDateSelectionModel,
  MAT_DATE_RANGE_SELECTION_STRATEGY,
} from "@angular/material/datepicker";
import { MatSelect } from "@angular/material/select";
import { UserDetailsService } from "../../services/user-details.service";
import { TasksService } from "../../services/task-service/tasks.service";
import { ApiService } from "../../services/api-service/api.service";
import { DatePipe } from "@angular/common";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { TimesheetSettingService } from "../../services/organization-settings/timesheet-setting.service";
@Component({
  selector: "app-task-reminder-component",
  templateUrl: "./task-reminder-component.component.html",
  styleUrls: ["./task-reminder-component.component.scss"],
  providers: [
    {
      provide: MAT_DATE_RANGE_SELECTION_STRATEGY,
      useClass: DefaultMatCalendarRangeStrategy,
    },
    DefaultMatCalendarRangeStrategy,
    MatRangeDateSelectionModel,
  ],
})
export class TaskReminderComponentComponent implements OnInit {
  minDueDate: any;
  selectedDueDate: any;
  @Input() reminderDetail: any;
  @ViewChild("select") select: MatSelect;
  @Output("selectedDate") selectedDate = new EventEmitter();
  @Output("closeMenu") closeMenu = new EventEmitter();
  dateRange: DateRange<Date>;
  startDate: any;
  endDate: any;
  date: any;
  reminderDateEpoch: any;
  isTaskRecurring = true;
  selectedOnDay: any;
  selectedOnDayArr: any[] = [];
  customOnDay: any;
  recurringDate: any;
  recurringDateEpoch: any;
  startTime: any;
  endTime: any;
  allSelected = false;
  isRepeat = false;
  repeatValue: any = 1;
  remindType: any;
  userDetail: any;
  reminderDataObj: any;
  selectedTime: any;
  hour: any;
  min: any;
  reminderObj: any;
  @Input() task_id: any;
  @Input() isTimesheetOn:any =false;
  remindTo: any = [
    { label: "Owner", checked: false },
    { label: "Assignees", checked: false },
    { label: "Followers", checked: false },
  ];
  reminderOption: any[] = [
    { name: " Notification", value: "pushup_notification", checked: true },
    { name: "Mail", value: "email", checked: false },
    { name: "Whatsapp", value: "whatsapp", checked: false },
  ];
  reminderAudience: any[] = [];
  isOn: any;
  minDate: any;
  maxDate: any;
  frequency: any = [
    {
      name: "Once",
      value: "once",
    },
    {
      name: "Daily",
      value: "daily",
    },
    {
      name: "Hourly",
      value: "hourly",
    },
    {
      name: "Weekly",
      value: "weekly",
    },
  ];

  weekDays = [
    {
      name: "Sunday",
      sortName: "SUN",
      isCheck: false,
    },
    {
      name: "Monday",
      sortName: "MON",
      isCheck: false,
    },
    {
      name: "Tuesday",
      sortName: "TUE",
      isCheck: false,
    },
    {
      name: "Wednesday",
      sortName: "WED",
      isCheck: false,
    },
    {
      name: "Thursday",
      sortName: "THU",
      isCheck: false,
    },
    {
      name: "Friday",
      sortName: "FRI",
      isCheck: false,
    },
    {
      name: "Saturday",
      sortName: "SAT",
      isCheck: false,
    },
  ];
  numbers = Array(28)
    .fill(1)
    .map((_x, index) => {
      return { id: index + 1, isCheck: false };
    });

  selectedFrequency = "";
  selectedWeekDays: any = [];
  newSelectedWeekDays: any = [];
  selectedHour:any = null;
  selectedMinute:any = null;
  hours: string[] = Array.from({ length: 24 }, (_, i) =>
    i.toString().padStart(2, "0")
  );
  minutes: string[] = ["00", "30"];
  isChange = false;

  scheduleForm!: FormGroup;

  constructor(
    private injector: Injector,
    private fb: FormBuilder,
    public timeSheetService: TimesheetSettingService,
    private readonly selectionModel: MatRangeDateSelectionModel<Date>,
    private readonly selectionStrategy: DefaultMatCalendarRangeStrategy<Date>,
    private taskService: TasksService,
    private apiService: ApiService,
    private datePipe: DatePipe,
  ) {
    this.userDetail = injector.get<UserDetailsService>(UserDetailsService);
    this.minDate = new Date();
  }

  async ngOnInit() {
    this.formInit();
    this.selectedTime = false;
    this.minDueDate = new Date();
    this.selectedDueDate = new Date(new Date().setHours(0,0,0,0));
    this.getAvailableHours();
    // this.selectedHour = "00";
    // this.selectedMinute = "00";
  }

  ngOnChanges(changes: any) {
    if(changes?.reminderDetail?.currentValue && !changes?.reminderDetail?.previousValue && !changes?.isTimesheetOn){
      this.reminderDataObj = JSON.parse(JSON.stringify(this.reminderDetail));
      this.getReminderData();
    }
  }

  async getTimesheetSettings(event?:any){
    if(event?.checked){
      const company_id = this.userDetail?.decryptedCompanyId(await this.userDetail.getSelectedCompanyId());
      (await this.timeSheetService.getTimesheetSetting(company_id)).subscribe((dataRes: any) => {
          if(dataRes?.result?.working_days){
            dataRes?.result?.working_days?.forEach((item:any) => {
              const index = this.weekDays.findIndex(
                d => d.sortName.toUpperCase() === item.day.toUpperCase()
              );
              if (index !== -1 && item.start_time && item.end_time && item.start_time !=="00:00" && item.end_time !=="00:00") {
                this.days.at(index).patchValue({
                  isCheck: true,
                  from: item.start_time,
                  to: item.end_time,
                });
              }
            });
          } 
      })
    }else{
      this.weekDays.forEach((ele:any,index:number)=>{
        this.days.at(index).patchValue({
          isCheck: false,
          from: '',
          to: '',
        });
      })
    }
  }

  formInit(){
    this.scheduleForm = this.fb.group({
      days: this.fb.array(this.weekDays.map(day =>
        this.fb.group({
          day: [day.name.toUpperCase()],
          day_sortname:[day.sortName.toUpperCase()],
          isCheck: [false],
          from: [''],
          to: ['']
        }, { validators: [this.timeValidator, this.isCheckWithTimeValidator] })
      ))
    });
  }

  get days(): FormArray<FormGroup> {
    return this.scheduleForm.get('days') as FormArray<FormGroup>;
  }


  autoPatchTime(index: number) {
    const current = this.days.at(index);

    if (current.value.isCheck) {
      for (let i = index - 1; i >= 0; i--) {
        const prev = this.days.at(i);
        if (prev.value.isCheck && prev.value.from && prev.value.to) {
          current.patchValue({
            from: prev.value.from,
            to: prev.value.to
          });
          break;
        }
      }
    } else {
      // optional: clear times if unchecked
      current.patchValue({ from: '', to: '' }, { emitEvent: false });
    }
  }

  timeValidator(group: AbstractControl): ValidationErrors | null {
    const from = group.get('from')?.value;
    const to = group.get('to')?.value;

    if (from && to && from >= to) {
      return { invalidTime: true };
    }
    return null;
  }

  isCheckWithTimeValidator(group: AbstractControl): ValidationErrors | null {
    const isCheck = group.get('isCheck')?.value;
    const from = group.get('from')?.value;
    const to = group.get('to')?.value;
  
    if (isCheck && (!from || !to)) {
      return { timeRequired: true }; // Validation error
    }
    return null; // Valid
  }

  

  async getReminderData() {
    this.isOn = this.reminderDataObj?.is_on;
    this.selectedDueDate = this.reminderDataObj?.reminder_date
      ? new Date(this.reminderDataObj?.reminder_date)
      : null;
    this.selectedFrequency = this.reminderDataObj?.repeat_frequency;

    this.selectedTime = this.datePipe.transform(this.selectedDueDate, "HH:mm");

    // this.selectedHour = this.datePipe.transform(this.selectedDueDate, "HH");
    // this.selectedMinute = this.datePipe.transform(this.selectedDueDate, "mm");


    // if (this.minutes.includes(this.selectedMinute)) {
    //   this.selectedMinute = this.datePipe.transform(this.selectedDueDate, "mm");
    // } else {
    //   this.selectedMinute = (
    //     Math.round(parseInt(this.selectedMinute) / 10) * 10
    //   ).toString();
    // }

    // if (
    //   0 < parseInt(this.selectedMinute) &&
    //   parseInt(this.selectedMinute) <= 30
    // ) {
    //   this.selectedMinute = this.minutes[1];
    // } else if (
    //   30 < parseInt(this.selectedMinute) ||
    //   parseInt(this.selectedMinute) == 0
    // ) {
    //   this.selectedMinute = this.minutes[0];
    // }


    if (this.reminderDataObj?.reminder_audience?.length) {
      this.remindTo.forEach((item: any) => {
        item.checked = this.reminderDataObj.reminder_audience.includes(
          item.label
        );
      });
    }
    if (this.reminderDataObj?.remind_via.length) {
      this.reminderOption.forEach((item: any) => {
        item.checked = this.reminderDataObj?.remind_via.includes(item.value);
      });
    }
    this.repeatValue = this.reminderDataObj?.repeat_value;
    this.selectedFrequency = this.reminderDataObj?.repeat_frequency;

    this.reminderDataObj?.manual_schedule?.forEach((item:any) => {
      const index = this.weekDays.findIndex(
        d => d.name.toUpperCase() === item.day.toUpperCase()
      );
      if (index !== -1) {
        this.days.at(index).patchValue({
          isCheck: true,
          from: item.from,
          to: item.to,
        });
      }
    });


    this.emitDataObj();
  }

  onFocus(type: any) {
    if (type == "hh") {
      this.hours = Array.from({ length: 24 }, (_, i) =>
        i.toString().padStart(2, "0")
      );
    } else if (type == "mm") {
      this.minutes = Array.from({ length: 6 }, (_, i) =>
        (i * 10).toString().padStart(2, "0")
      );
    }
  }

  onChangetoggle(event: any) {
    this.isTaskRecurring = event.checked;
    if (!this.isTaskRecurring) {
      this.resetAll();
    }
  }

  resetOnFrequencyChange() {
    this.weekDays.forEach((data: any) => {
      data.isCheck = false;
    });
    this.selectedWeekDays = [];
    this.selectedOnDay = "";
    this.customOnDay = "";
    this.recurringDate = "";
    setTimeout(() => {
      if (this.selectedFrequency === "once") {
        this.repeatValue = 1;
      }
    }, 200);
  }

  resetAll() {
    this.weekDays.forEach((data: any) => {
      data.isCheck = false;
    });
    this.selectedFrequency = "";
    this.selectedWeekDays = [];
    this.selectedOnDay = "";
    this.customOnDay = "";
    this.recurringDate = "";
  }

  selectFrequency(_d: any, data: any) {
    if (data.source._selected) {
      this.isRepeat = true;
    } else {
      this.isRepeat = false;
    }
    this.setMaxDate();
    this.resetOnFrequencyChange();
  }

  selectDays() {
    this.selectedOnDayArr = this.numbers
      .filter((ele: any) => ele.isCheck)
      .map((ele) => ele.id);
  }

  emitDataObj(done?: any) {
    const formValue = this.scheduleForm.value?.days;
    const manual_schedule = formValue?.filter((d: any) => d.isCheck && d.from && d.to)?.map((d: any) => ({
        day: d.day,
        from: d.from,
        to: d.to
    }));
    this.reminderOption[0].checked = true;
    const reminder_audience = this.remindTo
      .filter((item: any) => item.checked)
      .map((item: any) => item.label);
    const remind_via = this.reminderOption
      .filter((item: any) => item.checked)
      .map((item: any) => item.value);
    const epoch = new Date(this.selectedDueDate).getTime();
    const date = new Date(epoch);
    date.setSeconds(0);
    date.setMilliseconds(0);
    const data: any = {
      reminder_date: epoch,
      is_repeat: this.isRepeat,
      reminder_audience,
      remind_via,
      is_on: this.isOn,
      repeat_value: this.repeatValue,
      repeat_frequency: this.selectedFrequency || "once",
      next_reminder_date_time: date?.getTime(),
      task_id: "",
      manual_schedule: manual_schedule?.length ? manual_schedule:[]
    };
    
    this.selectedDate.emit(data);
    if (
      epoch &&
      this.isRepeat &&
      reminder_audience &&
      remind_via &&
      this.isOn &&
      this.repeatValue &&
      this.selectedFrequency &&
      done
    ) {
      this.closeMenu.emit(true);
      this.reminder();
    }
    if (!this.isOn) {
      this.closeMenu.emit(true);
      this.isOn = false;
      this.selectedDueDate = "";
      this.remindTo.forEach((item: any) => {
        item.checked = false;
      });
      this.selectedFrequency = "";
      this.selectedTime = "";
      this.repeatValue = "";
    }

    if (this.reminderDataObj && done) {
      
      this.updateReminder();
    }

    if (this.reminderDataObj?._id && !this.isOn) {
      this.deleteReminder();
      this.reminderDataObj = null;
    }
  }

  optionClick(list: any, eve: any) {
    list["checked"] = eve.checked;
  }

  allSelect(data: any, eve: any) {
    data.forEach((data: any) => {
      data["checked"] = eve.checked;
    });
  }

  isAllChecked(data: any) {
    return data.every((item: any) => item.checked);
  }

  setMaxDate() {
    this.maxDate = this.selectedDueDate;
  }

  clearData() {
    this.selectedDueDate = "";
    this.remindTo.forEach((item: any) => {
      item.checked = false;
    });
    this.selectedFrequency = "";
    this.selectedTime = "";
    this.repeatValue = "";
    this.selectedHour = null;
    this.selectedMinute = null;
    this.reminderOption[0].checked = true;
    this.reminderOption[1].checked = false;
    this.reminderOption[2].checked = false;
    this.emitDataObj();
  }

  close() {
    this.closeMenu.emit(true);
  }


  isValidForm() {
    const isReminderVia = this.reminderOption.some((item: any) => item.checked);
    const isReminderAudiance = this.remindTo.some((item: any) => item.checked);
    let selectTime = false;
    if (this.selectedTime) {
      selectTime = true;
    }
    return (

      !this.selectedDueDate ||
      !this.selectedFrequency ||
      !this.repeatValue ||
      !isReminderVia ||
      !isReminderAudiance ||
      !selectTime || !this.scheduleForm.valid
    );
  }

  async updateReminder() {
    const formValue = this.scheduleForm.value?.days;
    const manual_schedule = formValue?.filter((d: any) => d.isCheck && d.from && d.to)?.map((d: any) => ({
        day: d.day,
        from: d.from,
        to: d.to
    }));

    const reminder_audience = this.remindTo
      .filter((item: any) => item.checked)
      .map((item: any) => item.label);
    const remind_via = this.reminderOption
      .filter((item: any) => item.checked)
      .map((item: any) => item.value);
    const epoch = new Date(this.selectedDueDate).getTime();
    const date = new Date(epoch);
    date.setSeconds(0);
    date.setMilliseconds(0);

    this.reminderObj = {
      reminder_date: epoch,
      is_repeat: this.isRepeat,
      reminder_audience: reminder_audience,
      remind_via: remind_via,
      is_on: this.isOn,
      repeat_value: this.repeatValue,
      repeat_frequency: this.selectedFrequency,
      next_reminder_date_time: date?.getTime(),
      task_id: this.reminderDataObj?.task_id,
      manual_schedule: manual_schedule?.length ? manual_schedule:[]
    };

    delete this.reminderObj.task_id;
    delete this.reminderObj.next_reminder_date_time;
    
    if (this.reminderObj.is_on && this.reminderDataObj?._id) {
      (
        await this.taskService.editReminder(
          this.reminderDataObj?._id,
          this.reminderObj
        )
      ).subscribe((res: any) => {
        this.apiService.showSuccess(res.message);
        this.updateFlag();
      });
    }
  }

  async deleteReminder() {
    (
      await this.taskService.deleteReminder(
        this.reminderDataObj?.task_id,
        this.reminderDataObj?._id
      )
    ).subscribe((res: any) => {
      // do something after the reminder response
      this.apiService.showSuccess(res.message);
      this.reminderOption[0].checked = true;
      this.reminderOption[1].checked = false;
      this.reminderOption[2].checked = false;
      this.updateFlag();
    });
  }

  async updateFlag() {
    const updateObj: any = {
      reminder_on: this.isOn,
      task_id: this.task_id,
    };
    await this.taskService.editReminderFlag(updateObj);
  }

  async reminder() {
    const formValue = this.scheduleForm.value?.days;
    const manual_schedule = formValue?.filter((d: any) => d.isCheck && d.from && d.to)?.map((d: any) => ({
        day: d.day,
        from: d.from,
        to: d.to
    }));
    const reminder_audience = this.remindTo
      .filter((item: any) => item.checked)
      .map((item: any) => item.label);
    const remind_via = this.reminderOption
      .filter((item: any) => item.checked)
      .map((item: any) => item.value);
    const epoch = new Date(this.selectedDueDate).getTime();
    const date = new Date(epoch);
    date.setSeconds(0);
    date.setMilliseconds(0);

    this.reminderObj = {
      reminder_date: epoch,
      is_repeat: this.isRepeat,
      reminder_audience: reminder_audience,
      remind_via: remind_via,
      is_on: this.isOn,
      repeat_value: this.repeatValue,
      repeat_frequency: this.selectedFrequency,
      next_reminder_date_time: date?.getTime(),
      task_id: this.task_id,
      manual_schedule: manual_schedule?.length ? manual_schedule:[]
    };
    if (this.isOn && this.task_id && !this.reminderDataObj?._id) {
      (await this.taskService.addReminder(this.reminderObj)).subscribe(
        (res: any) => {
          this.apiService.showSuccess(res.message);
          this.getReminderDetail();
          // do something after the reminder response
          this.updateFlag();
        }
      );
    }
  }

  async getReminderDetail() {
    (await this.taskService.getReminder(this.task_id)).subscribe((res: any) => {
      this.reminderDataObj = res.result;
    });
  }

  // --- helpers (add to your component class) ---
private pad(n: number) {
  return n.toString().padStart(2, '0');
}

private isSameDay(a: Date, b: Date) {
  return (
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate()
  );
}

private range(start: number, end: number) {
  const out: number[] = [];
  for (let i = start; i <= end; i++) out.push(i);
  return out;
}

/**
 * Compute allowed minute options (["00","30"] or ["30"] or []) for a given hour
 * depending on "now" and whether the selected date is today.
 */
private _getAllowedMinutesForHour(hour: number, now: Date, isToday: boolean): string[] {
  if (!isToday) return ['00', '30'];

  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  if (hour < currentHour) return []; // past hour
  if (hour === currentHour) {
    // if current minute < 30 -> only "30" of current hour is allowed
    // if current minute >= 30 -> current hour is not allowed at all (hours will start from next hour)
    return currentMinute < 30 ? ['30'] : [];
  }
  // hour > currentHour -> both 00 and 30 allowed
  return ['00', '30'];
}

// --- getAvailableHours (replace existing implementation) ---
async getAvailableHours() {
  const now = new Date();
  // normalize/ensure selectedDueDate is Date
  let selectedDate = this.selectedDueDate instanceof Date
    ? new Date(this.selectedDueDate)
    : new Date(this.selectedDueDate);

  if (isNaN(selectedDate.getTime())) {
    // fallback to today if invalid
    selectedDate = new Date();
    this.selectedDueDate = selectedDate;
  }

  const isToday = this.isSameDay(selectedDate, now);
  const currentHour = now.getHours();
  const currentMinute = now.getMinutes();

  if (isToday) {
    if (currentMinute < 30) {
      // allow current hour (but only :30) and all future hours today
      const startHour = currentHour;
      this.hours = this.range(startHour, 23).map(h => this.pad(h));
      // default minute view for the hour dropdown initially: we will further refine when user picks an hour
      this.minutes = ['30'];
    } else {
      // minute >= 30 -> start from next hour (00/30 for the next hours)
      const startHour = currentHour + 1;
      if (startHour > 23) {
        // no hours left today
        this.hours = [];
        this.minutes = [];
        this.selectedHour = null;
        this.selectedMinute = null;
        return;
      }
      this.hours = this.range(startHour, 23).map(h => this.pad(h));
      this.minutes = ['00', '30'];
    }
  } else {
    // future date -> full day allowed
    this.hours = this.range(0, 23).map(h => this.pad(h));
    this.minutes = ['00', '30'];
  }

  // Ensure current selection is still valid. If not, clear or auto-fix.
  if (this.selectedHour != null) {
    const selHourStr = this.pad(Number(this.selectedHour));
    if (!this.hours.includes(selHourStr)) {
      // selected hour is not allowed for this date, clear it
      this.selectedHour = null;
      this.selectedMinute = null;
    } else {
      // update minutes according to the selected hour
      const allowed = this._getAllowedMinutesForHour(Number(selHourStr), now, isToday);
      this.minutes = allowed;
      if (this.selectedMinute == null || !allowed.includes(this.pad(Number(this.selectedMinute)))) {
        // keep selection safe (null) — UI will show correct minute choices
        this.selectedMinute = null;
      }
    }
  } else {
    // no hour selected yet: nothing to do
    this.selectedMinute = null;
  }
}

// --- timeSelection (replace existing implementation) ---
timeSelection() {
  // 1) Ensure we have a real Date object (clone)
  const base = this.selectedDueDate instanceof Date
    ? new Date(this.selectedDueDate)
    : new Date(this.selectedDueDate);

  if (isNaN(base.getTime())) {
    this.selectedDueDate = new Date();
  } else {
    this.selectedDueDate = new Date(base);
  }

  // raw model values (ngModel may supply string like "17")
  const rawHour = this.selectedHour;
  const rawMinute = this.selectedMinute;

  if (rawHour == null) {
    // no hour chosen yet — nothing to set
    console.warn('Hour missing; skipping time update.');
    return;
  }

  // coerce hour to number
  let hour = Number(rawHour);
  if (Number.isNaN(hour)) {
    console.warn('Hour is NaN; skipping.');
    return;
  }

  // Decide allowed minutes for this hour
  const now = new Date();
  const selectedDate = this.selectedDueDate instanceof Date ? new Date(this.selectedDueDate) : new Date(this.selectedDueDate);
  const isToday = this.isSameDay(selectedDate, now);

  // If the chosen hour is not permitable for today, auto-correct to the first allowed hour/minute.
  let allowedMinutes = this._getAllowedMinutesForHour(hour, now, isToday);

  if (allowedMinutes.length === 0) {
    // chosen hour is in the past (or not allowed). Pick the earliest allowed hour from this.hours.
    if (this.hours && this.hours.length > 0) {
      const firstAllowedHourStr = this.hours[0];
      hour = Number(firstAllowedHourStr);
      this.selectedHour = firstAllowedHourStr;
      allowedMinutes = this._getAllowedMinutesForHour(hour, now, isToday);
      // make sure minutes list reflects allowed minutes for this newly selected hour
      this.minutes = allowedMinutes;
      this.selectedMinute = allowedMinutes.length ? allowedMinutes[0] : null;
    } else {
      // no hours available at all (e.g. late night, no slots today)
      this.selectedHour = null;
      this.selectedMinute = null;
      this.minutes = [];
      console.warn('No hours available for that date.');
      return;
    }
  } else {
    // chosen hour is allowed; ensure minute selection is valid
    // if user hasn't chosen a minute or chose one not in allowedMinutes, choose the first allowed
    const minuteStr = rawMinute == null ? null : this.pad(Number(rawMinute));
    if (minuteStr == null || !allowedMinutes.includes(minuteStr)) {
      // set to first allowed minute
      this.selectedMinute = allowedMinutes[0];
    }
    // update minutes shown in the UI
    this.minutes = allowedMinutes;
  }

  // now we are safe to set the date time
  const minute = Number(this.selectedMinute ?? 0);
  this.selectedDueDate.setHours(hour, minute, 0, 0);

  // update the visible time string
  this.selectedTime = `${this.pad(hour)}:${this.pad(minute)}`;

  // emit
  this.emitDataObj();
}

  async resetHours() {

    this.selectedHour = null;
    this.selectedMinute = null;
    const today = new Date();
    const selected = new Date(this.selectedDueDate);
    
    // Normalize dates to ignore time (compare only date part)
    const isToday =
    selected.getFullYear() === today.getFullYear() &&
    selected.getMonth() === today.getMonth() &&
    selected.getDate() === today.getDate();
    
    if (isToday) {
      this.selectedTime = null;
      await this.getAvailableHours();
    } else {
      this.hours = [];
      this.hours = Array.from({ length: 24 }, (_, i) =>
      i.toString().padStart(2, "0")
      );
      this.selectedHour = null;
    }
    
    let [hours, minutes] = (this.selectedTime||"00:00")?.split(':')?.map(Number);
    
    this.selectedDueDate.setHours(hours||0, minutes||0, 0, 0);
  }
}
